import { createAsyncAction } from "typesafe-actions";
import ActionType from "./ActionType";
import { OptionListModel } from "../../model/OptionModel";

export const getOptionList = createAsyncAction(
    ActionType.GET_OPTION_REQUEST,
    ActionType.GET_OPTION_SUCCEEDED,
    ActionType.GET_OPTION_FAILED
)<void, OptionListModel, Error>();
